import { IMAGE_SIZE } from '@api/media/constants';
import * as utils from '@utils/form';

export const CHANNEL_ITEM_FIELDS = {
  CATEGORY: {
    name: 'category',
    label: 'Category',
    placeholder: 'Choose category',
    options: [
      { label: 'Live Stream', value: 'Live Stream' },
      { label: 'Highlights', value: 'Highlights' },
      { label: 'Radio', value: 'Radio' },
    ],
    rules: [{ required: true, message: 'Category is required' }],
  },
  CHANNEL: {
    name: 'channel',
    label: 'Channel',
    placeholder: 'Type to search channel:',
    rules: [{ required: true, message: 'Channel is required' }],
    serialize: (field, values) => {
      return {
        title: values.channel.title,
        channelId: values.channel.id,
        logoId: values.channel.logoId,
        logoFileName: values.channel.logoFileName,
      };
    },
    deserialize: (field, serverData) => {
      const id = serverData.channelId;
      const title = serverData.title;
      const logoId = serverData.logoId;
      const logoFileName = serverData.logoFileName;

      return { [field.name]: { id, title, logoId, logoFileName } };
    },
  },
  DAYS: {
    name: 'days',
  },
};

export const GENERAL_CHANNELS = {
  name: 'eventLevelGeneralChannels',
  serialize: (field, values) => {
    const value = values[field.name];
    return {
      eventLevelGeneralChannels: value,
    };
  },
};

export const DAY_FIELDS = {
  COUNTRIES: { name: 'countries' },
  DAY: {
    name: 'day',
  },
  SESSION_FIRST_URL: {
    name: 'sessionFirstUrl',
    label: 'Session 1 URL',
    placeholder: 'Enter the url',
    rules: [
      { type: 'url', message: "Doesn't look like a valid URL" },
      { required: true, message: 'URL is required' },
    ],
  },
  SESSION_SECOND_URL: {
    name: 'sessionSecondUrl',
    label: 'Session 2 URL',
    placeholder: 'Enter the url',
    rules: [
      { type: 'url', message: "Doesn't look like a valid URL" },
      { required: true, message: 'URL is required' },
    ],
  },
};

export const FORM_FIELD = {
  DESKTOP_BANNER: {
    name: 'desktopBanner',
    label: 'Desktop banner:',
    size: IMAGE_SIZE['2000x240'],
    serialize: (field, values) => ({
      [`${field.name}Id`]: values[field.name]?.id,
      [`${field.name}FileName`]: values[field.name]?.fileName,
      [`${field.name}ImageEdited`]: values[field.name]?.edited,
    }),
    deserialize: (field, data) => {
      const { id, edited, fileName } = {
        id: data[`${field.name}Id`],
        edited: data[`${field.name}ImageEdited`],
        fileName: data[`${field.name}FileName`],
      };

      if (!id) return null;

      return { [field.name]: { id, edited, fileName } };
    },
    deserializeError: utils.deserializeErrorRelatedField,
  },
  MOBILE_BANNER: {
    name: 'mobileBanner',
    label: 'Mobile banner:',
    size: IMAGE_SIZE['700x300'],
    serialize: (field, values) => ({
      [`${field.name}Id`]: values[field.name]?.id,
      [`${field.name}FileName`]: values[field.name]?.fileName,
      [`${field.name}ImageEdited`]: values[field.name]?.edited,
    }),
    deserialize: (field, data) => {
      const { id, edited, fileName } = {
        id: data[`${field.name}Id`],
        edited: data[`${field.name}ImageEdited`],
        fileName: data[`${field.name}FileName`],
      };

      if (!id) return null;

      return { [field.name]: { id, edited, fileName } };
    },
    deserializeError: utils.deserializeErrorRelatedField,
  },
  INTRO_TEXT: {
    name: 'introText',
    label: 'Intro Text:',
    placeholder: 'Enter the description',
  },
  BOTTOM_TEXT: {
    name: 'bottomText',
    label: 'Bottom Text:',
    placeholder: 'Enter the description',
  },
  BANNER_STRAPLINE: {
    name: 'bannerStrapline',
    label: 'Banner Strapline:',
    placeholder: 'Enter the strapline',
  },
  BANNER_URL: {
    name: 'bannerUrl',
    label: 'Banner URL',
    placeholder: 'Enter banner URL',
    rules: [{ type: 'url', message: "Doesn't look like a valid URL" }],
  },
  LIVE: {
    name: 'isLive',
    label: 'Set Live',
  },
  GENERAL_CHANNELS,
  ID: { name: 'id' },
};

export const FORM_FIELDS = Object.values(FORM_FIELD);

export const WHERE_TO_WATCH_INITS = {
  [FORM_FIELD.INTRO_TEXT.name]: '',
  [FORM_FIELD.BOTTOM_TEXT.name]: '',
  [FORM_FIELD.MOBILE_BANNER.name]: '',
  [FORM_FIELD.DESKTOP_BANNER.name]: '',
  [FORM_FIELD.GENERAL_CHANNELS.name]: [],
  [FORM_FIELD.BANNER_STRAPLINE.name]: '',
  [FORM_FIELD.ID.name]: null,
};

export const EVENT_CHANNELS_INITS = {
  category: 'Live Stream',
  channel: {},
  id: null,
  days: [],
};

export const CHANNEL_DAY_INITS = {
  [DAY_FIELDS.DAY.name]: null,
  [DAY_FIELDS.SESSION_FIRST_URL.name]: '',
  [DAY_FIELDS.SESSION_SECOND_URL.name]: '',
  countries: [],
};

export const countriesWithRegions = [
  {
    id: 'GAM',
    region: 'Africa',
  },
  {
    id: 'ALA',
    region: 'Europe',
  },
  {
    id: 'CPV',
    region: 'Africa',
  },
  {
    id: 'TKM',
    region: 'Asia',
  },
  {
    id: 'QAT',
    region: 'Asia',
  },
  {
    id: 'ESA',
    region: 'Americas',
  },
  {
    id: 'GEO',
    region: 'Asia',
  },
  {
    id: 'GEQ',
    region: 'Africa',
  },
  {
    id: 'CIV',
    region: 'Africa',
  },
  {
    id: 'BHR',
    region: 'Asia',
  },
  {
    id: 'FIN',
    region: 'Europe',
  },
  {
    id: 'LBA',
    region: 'Africa',
  },
  {
    id: 'ESH',
    region: 'Africa',
  },
  {
    id: 'ETH',
    region: 'Africa',
  },
  {
    id: 'MNP',
    region: 'Oceania',
  },
  {
    id: 'BVT',
    region: 'Antarctic',
  },
  {
    id: 'SSD',
    region: 'Africa',
  },
  {
    id: 'MYT',
    region: 'Africa',
  },
  {
    id: 'PLE',
    region: 'Asia',
  },
  {
    id: 'TCA',
    region: 'Americas',
  },
  {
    id: 'KGZ',
    region: 'Asia',
  },
  {
    id: 'MDV',
    region: 'Asia',
  },
  {
    id: 'BAN',
    region: 'Asia',
  },
  {
    id: 'ASA',
    region: 'Oceania',
  },
  {
    id: 'CRO',
    region: 'Europe',
  },
  {
    id: 'CAY',
    region: 'Americas',
  },
  {
    id: 'AFG',
    region: 'Asia',
  },
  {
    id: 'HAI',
    region: 'Americas',
  },
  {
    id: 'ANT',
    region: 'Americas',
  },
  {
    id: 'VEN',
    region: 'Americas',
  },
  {
    id: 'IRL',
    region: 'Europe',
  },
  {
    id: 'CAN',
    region: 'Americas',
  },
  {
    id: 'VIN',
    region: 'Americas',
  },
  {
    id: 'PAR',
    region: 'Americas',
  },
  {
    id: 'TUV',
    region: 'Oceania',
  },
  {
    id: 'MLI',
    region: 'Africa',
  },
  {
    id: 'AUT',
    region: 'Europe',
  },
  {
    id: 'MYA',
    region: 'Asia',
  },
  {
    id: 'BEN',
    region: 'Africa',
  },
  {
    id: 'CUB',
    region: 'Americas',
  },
  {
    id: 'BAH',
    region: 'Americas',
  },
  {
    id: 'ISV',
    region: 'Americas',
  },
  {
    id: 'UKR',
    region: 'Europe',
  },
  {
    id: 'ARU',
    region: 'Americas',
  },
  {
    id: 'SUI',
    region: 'Europe',
  },
  {
    id: 'LIE',
    region: 'Europe',
  },
  {
    id: 'COM',
    region: 'Africa',
  },
  {
    id: 'SYR',
    region: 'Asia',
  },
  {
    id: 'BRU',
    region: 'Asia',
  },
  {
    id: 'CUW',
    region: 'Americas',
  },
  {
    id: 'GGY',
    region: 'Europe',
  },
  {
    id: 'LBR',
    region: 'Africa',
  },
  {
    id: 'JPN',
    region: 'Asia',
  },
  {
    id: 'SAM',
    region: 'Oceania',
  },
  {
    id: 'SOL',
    region: 'Oceania',
  },
  {
    id: 'CAF',
    region: 'Africa',
  },
  {
    id: 'ITA',
    region: 'Europe',
  },
  {
    id: 'REU',
    region: 'Africa',
  },
  {
    id: 'TOG',
    region: 'Africa',
  },
  {
    id: 'TUN',
    region: 'Africa',
  },
  {
    id: 'TPE',
    region: 'Asia',
  },
  {
    id: 'COD',
    region: 'Africa',
  },
  {
    id: 'MEX',
    region: 'Americas',
  },
  {
    id: 'LAO',
    region: 'Asia',
  },
  {
    id: 'NAM',
    region: 'Africa',
  },
  {
    id: 'KSA',
    region: 'Asia',
  },
  {
    id: 'FRO',
    region: 'Europe',
  },
  {
    id: 'GRE',
    region: 'Europe',
  },
  {
    id: 'NIG',
    region: 'Africa',
  },
  {
    id: 'HKG',
    region: 'Asia',
  },
  {
    id: 'CMR',
    region: 'Africa',
  },
  {
    id: 'SUR',
    region: 'Americas',
  },
  {
    id: 'ECU',
    region: 'Americas',
  },
  {
    id: 'RUS',
    region: 'Europe',
  },
  {
    id: 'DMA',
    region: 'Americas',
  },
  {
    id: 'MON',
    region: 'Europe',
  },
  {
    id: 'MOZ',
    region: 'Africa',
  },
  {
    id: 'KOS',
    region: 'Europe',
  },
  {
    id: 'IRQ',
    region: 'Asia',
  },
  {
    id: 'MNE',
    region: 'Europe',
  },
  {
    id: 'BLM',
    region: 'Americas',
  },
  {
    id: 'MGL',
    region: 'Asia',
  },
  {
    id: 'CHA',
    region: 'Africa',
  },
  {
    id: 'IVB',
    region: 'Americas',
  },
  {
    id: 'KEN',
    region: 'Africa',
  },
  {
    id: 'CAM',
    region: 'Asia',
  },
  {
    id: 'POR',
    region: 'Europe',
  },
  {
    id: 'SOM',
    region: 'Africa',
  },
  {
    id: 'FLK',
    region: 'Americas',
  },
  {
    id: 'PCN',
    region: 'Oceania',
  },
  {
    id: 'NCA',
    region: 'Americas',
  },
  {
    id: 'SRI',
    region: 'Asia',
  },
  {
    id: 'NOR',
    region: 'Europe',
  },
  {
    id: 'MTQ', //MRT Martinique
    region: 'Americas',
  },
  {
    id: 'SEY',
    region: 'Africa',
  },
  {
    id: 'MAD',
    region: 'Africa',
  },
  {
    id: 'NZL',
    region: 'Oceania',
  },
  {
    id: 'SKN',
    region: 'Americas',
  },
  {
    id: 'NIU',
    region: 'Oceania',
  },
  {
    id: 'TLS',
    region: 'Asia',
  },
  {
    id: 'PAK',
    region: 'Asia',
  },
  {
    id: 'CZE',
    region: 'Europe',
  },
  {
    id: 'WLF',
    region: 'Oceania',
  },
  {
    id: 'TAN',
    region: 'Africa',
  },
  {
    id: 'STP',
    region: 'Africa',
  },
  {
    id: 'ISR',
    region: 'Asia',
  },
  {
    id: 'BHU',
    region: 'Asia',
  },
  {
    id: 'ALB',
    region: 'Europe',
  },
  {
    id: 'BOL',
    region: 'Americas',
  },
  {
    id: 'CYP',
    region: 'Europe',
  },
  {
    id: 'GUA',
    region: 'Americas',
  },
  {
    id: 'MAF',
    region: 'Americas',
  },
  {
    id: 'LTU',
    region: 'Europe',
  },
  {
    id: 'HUN',
    region: 'Europe',
  },
  {
    id: 'SEN',
    region: 'Africa',
  },
  {
    id: 'THA',
    region: 'Asia',
  },
  {
    id: 'PYF',
    region: 'Oceania',
  },
  {
    id: 'TJK',
    region: 'Asia',
  },
  {
    id: 'BIH',
    region: 'Europe',
  },
  {
    id: 'SUD',
    region: 'Africa',
  },
  {
    id: 'POL',
    region: 'Europe',
  },
  {
    id: 'MHL',
    region: 'Oceania',
  },
  {
    id: 'ATF',
    region: 'Antarctic',
  },
  {
    id: 'JEY',
    region: 'Europe',
  },
  {
    id: 'HON',
    region: 'Americas',
  },
  {
    id: 'MAC',
    region: 'Asia',
  },
  {
    id: 'MSR',
    region: 'Americas',
  },
  {
    id: 'CXR',
    region: 'Oceania',
  },
  {
    id: 'NED',
    region: 'Europe',
  },
  {
    id: 'CRC',
    region: 'Americas',
  },
  {
    id: 'FSM',
    region: 'Oceania',
  },
  {
    id: 'KIR',
    region: 'Oceania',
  },
  {
    id: 'GRL',
    region: 'Americas',
  },
  {
    id: 'ATA',
    region: 'Antarctic',
  },
  {
    id: 'NGR',
    region: 'Africa',
  },
  {
    id: 'SLO',
    region: 'Europe',
  },
  {
    id: 'DJI',
    region: 'Africa',
  },
  {
    id: 'IRI',
    region: 'Asia',
  },
  {
    id: 'TUR',
    region: 'Asia',
  },
  {
    id: 'PNG',
    region: 'Oceania',
  },
  {
    id: 'BOT',
    region: 'Africa',
  },
  {
    id: 'USA',
    region: 'Americas',
  },
  {
    id: 'KOR',
    region: 'Asia',
  },
  {
    id: 'ALG',
    region: 'Africa',
  },
  {
    id: 'GAB',
    region: 'Africa',
  },
  {
    id: 'ROU',
    region: 'Europe',
  },
  {
    id: 'VAN',
    region: 'Oceania',
  },
  {
    id: 'DOM',
    region: 'Americas',
  },
  {
    id: 'PLW',
    region: 'Oceania',
  },
  {
    id: 'SPM',
    region: 'Americas',
  },
  {
    id: 'IND',
    region: 'Asia',
  },
  {
    id: 'LES',
    region: 'Africa',
  },
  {
    id: 'NCL',
    region: 'Oceania',
  },
  {
    id: 'LAT',
    region: 'Europe',
  },
  {
    id: 'BRA',
    region: 'Americas',
  },
  {
    id: 'MAR',
    region: 'Africa',
  },
  {
    id: 'RWA',
    region: 'Africa',
  },
  {
    id: 'IMN',
    region: 'Europe',
  },
  {
    id: 'BER',
    region: 'Americas',
  },
  {
    id: 'MRI',
    region: 'Africa',
  },
  {
    id: 'SXM',
    region: 'Americas',
  },
  {
    id: 'YEM',
    region: 'Asia',
  },
  {
    id: 'FRA',
    region: 'Europe',
  },
  {
    id: 'MDA',
    region: 'Europe',
  },
  {
    id: 'UZB',
    region: 'Asia',
  },
  {
    id: 'CCK',
    region: 'Oceania',
  },
  {
    id: 'NRU',
    region: 'Oceania',
  },
  {
    id: 'UGA',
    region: 'Africa',
  },
  {
    id: 'CGO',
    region: 'Africa',
  },
  {
    id: 'COL',
    region: 'Americas',
  },
  {
    id: 'PUR',
    region: 'Americas',
  },
  {
    id: 'KAZ',
    region: 'Asia',
  },
  {
    id: 'EST',
    region: 'Europe',
  },
  {
    id: 'BUL',
    region: 'Europe',
  },
  {
    id: 'HMD',
    region: 'Antarctic',
  },
  {
    id: 'TKL',
    region: 'Oceania',
  },
  {
    id: 'BIZ',
    region: 'Americas',
  },
  {
    id: 'UMI',
    region: 'Americas',
  },
  {
    id: 'UAE',
    region: 'Asia',
  },
  {
    id: 'PER',
    region: 'Americas',
  },
  {
    id: 'OMA',
    region: 'Asia',
  },
  {
    id: 'SGS',
    region: 'Antarctic',
  },
  {
    id: 'SWE',
    region: 'Europe',
  },
  {
    id: 'URU',
    region: 'Americas',
  },
  {
    id: 'RSA',
    region: 'Africa',
  },
  {
    id: 'MLT',
    region: 'Europe',
  },
  {
    id: 'BLR',
    region: 'Europe',
  },
  {
    id: 'TGA',
    region: 'Oceania',
  },
  {
    id: 'COK',
    region: 'Oceania',
  },
  {
    id: 'NEP',
    region: 'Asia',
  },
  {
    id: 'VAT',
    region: 'Europe',
  },
  {
    id: 'BAR',
    region: 'Americas',
  },
  {
    id: 'SVK',
    region: 'Europe',
  },
  {
    id: 'GUF',
    region: 'Americas',
  },
  {
    id: 'MKD',
    region: 'Europe',
  },
  {
    id: 'GER',
    region: 'Europe',
  },
  {
    id: 'AND',
    region: 'Europe',
  },
  {
    id: 'GUM',
    region: 'Oceania',
  },
  {
    id: 'PHI',
    region: 'Asia',
  },
  {
    id: 'BDI',
    region: 'Africa',
  },
  {
    id: 'GUY',
    region: 'Americas',
  },
  {
    id: 'SJM',
    region: 'Europe',
  },
  {
    id: 'BUR',
    region: 'Africa',
  },
  {
    id: 'ZAM',
    region: 'Africa',
  },
  {
    id: 'SLE',
    region: 'Africa',
  },
  {
    id: 'GBR',
    region: 'Europe',
  },
  {
    id: 'AIA',
    region: 'Americas',
  },
  {
    id: 'GLP',
    region: 'Americas',
  },
  {
    id: 'GDL',
    region: 'Americas',
  },
  {
    id: 'LBN',
    region: 'Asia',
  },
  {
    id: 'ISL',
    region: 'Europe',
  },
  {
    id: 'JOR',
    region: 'Asia',
  },
  {
    id: 'NFK',
    region: 'Oceania',
  },
  {
    id: 'JAM',
    region: 'Americas',
  },
  {
    id: 'SGP',
    region: 'Asia',
  },
  {
    id: 'MTN',
    region: 'Africa',
  },
  {
    id: 'SHN',
    region: 'Africa',
  },
  {
    id: 'GBS',
    region: 'Africa',
  },
  {
    id: 'MAS',
    region: 'Asia',
  },
  {
    id: 'GUI',
    region: 'Africa',
  },
  {
    id: 'GRN',
    region: 'Americas',
  },
  {
    id: 'LUX',
    region: 'Europe',
  },
  {
    id: 'MAW',
    region: 'Africa',
  },
  {
    id: 'VIE',
    region: 'Asia',
  },
  {
    id: 'AUS',
    region: 'Oceania',
  },
  {
    id: 'EGY',
    region: 'Africa',
  },
  {
    id: 'ZIM',
    region: 'Africa',
  },
  {
    id: 'INA',
    region: 'Asia',
  },
  {
    id: 'SMR',
    region: 'Europe',
  },
  {
    id: 'ANG',
    region: 'Africa',
  },
  {
    id: 'PRK',
    region: 'Asia',
  },
  {
    id: 'FIJ',
    region: 'Oceania',
  },
  {
    id: 'GHA',
    region: 'Africa',
  },
  {
    id: 'DEN',
    region: 'Europe',
  },
  {
    id: 'ERI',
    region: 'Africa',
  },
  {
    id: 'ARM',
    region: 'Asia',
  },
  {
    id: 'CHI',
    region: 'Americas',
  },
  {
    id: 'TTO',
    region: 'Americas',
  },
  {
    id: 'ARG',
    region: 'Americas',
  },
  {
    id: 'KUW',
    region: 'Asia',
  },
  {
    id: 'LCA',
    region: 'Americas',
  },
  {
    id: 'BES',
    region: 'Americas',
  },
  {
    id: 'GIB',
    region: 'Europe',
  },
  {
    id: 'PAN',
    region: 'Americas',
  },
  {
    id: 'CHN',
    region: 'Asia',
  },
  {
    id: 'SWZ',
    region: 'Africa',
  },
  {
    id: 'ESP',
    region: 'Europe',
  },
  {
    id: 'AZE',
    region: 'Asia',
  },
  {
    id: 'BEL',
    region: 'Europe',
  },
  {
    id: 'SRB',
    region: 'Europe',
  },
  {
    id: 'IOT',
    region: 'Africa',
  },
];

export const regions = {
  Africa: [
    'GAM',
    'CPV',
    'GEQ',
    'CIV',
    'LBA',
    'ESH',
    'ETH',
    'SSD',
    'MYT',
    'MLI',
    'BEN',
    'COM',
    'LBR',
    'CAF',
    'REU',
    'TOG',
    'TUN',
    'COD',
    'NAM',
    'NIG',
    'CMR',
    'MOZ',
    'CHA',
    'KEN',
    'SOM',
    'SEY',
    'MAD',
    'TAN',
    'STP',
    'SEN',
    'SUD',
    'NGR',
    'DJI',
    'BOT',
    'ALG',
    'GAB',
    'LES',
    'MAR',
    'RWA',
    'MRI',
    'UGA',
    'CGO',
    'RSA',
    'BDI',
    'BUR',
    'ZAM',
    'SLE',
    'MTN',
    'SHN',
    'GBS',
    'GUI',
    'MAW',
    'EGY',
    'ZIM',
    'ANG',
    'GHA',
    'ERI',
    'SWZ',
    'IOT',
  ],
  Europe: [
    'ALA',
    'FIN',
    'CRO',
    'IRL',
    'AUT',
    'UKR',
    'SUI',
    'LIE',
    'GGY',
    'ITA',
    'FRO',
    'GRE',
    'RUS',
    'MON',
    'KOS',
    'MNE',
    'POR',
    'NOR',
    'CZE',
    'ALB',
    'CYP',
    'LTU',
    'HUN',
    'BIH',
    'POL',
    'JEY',
    'NED',
    'SLO',
    'ROU',
    'LAT',
    'IMN',
    'FRA',
    'MDA',
    'EST',
    'BUL',
    'SWE',
    'MLT',
    'BLR',
    'VAT',
    'SVK',
    'MKD',
    'GER',
    'AND',
    'SJM',
    'GBR',
    'ISL',
    'LUX',
    'SMR',
    'DEN',
    'GIB',
    'ESP',
    'BEL',
    'SRB',
  ],
  Asia: [
    'TKM',
    'QAT',
    'GEO',
    'BHR',
    'PLE',
    'KGZ',
    'MDV',
    'BAN',
    'AFG',
    'MYA',
    'SYR',
    'BRU',
    'JPN',
    'TPE',
    'LAO',
    'KSA',
    'HKG',
    'IRQ',
    'MGL',
    'CAM',
    'SRI',
    'TLS',
    'PAK',
    'ISR',
    'BHU',
    'THA',
    'TJK',
    'MAC',
    'IRI',
    'TUR',
    'KOR',
    'IND',
    'YEM',
    'UZB',
    'KAZ',
    'UAE',
    'OMA',
    'NEP',
    'PHI',
    'LBN',
    'JOR',
    'SGP',
    'MAS',
    'VIE',
    'INA',
    'PRK',
    'ARM',
    'KUW',
    'CHN',
    'AZE',
  ],
  Americas: [
    'MRT',
    'MNT', // Montserrat
    'TKS', // turks and caicos
    'ESA',
    'TCA',
    'CAY',
    'HAI',
    'ANT',
    'VEN',
    'CAN',
    'VIN',
    'PAR',
    'CUB',
    'BAH',
    'ISV',
    'ARU',
    'CUW',
    'MEX',
    'SUR',
    'ECU',
    'DMA',
    'BLM',
    'IVB',
    'FLK',
    'NCA',
    'MTQ',
    'SKN',
    'BOL',
    'GUA',
    'MAF',
    'HON',
    'MSR',
    'CRC',
    'GRL',
    'USA',
    'DOM',
    'SPM',
    'BRA',
    'BER',
    'SXM',
    'COL',
    'PUR',
    'BIZ',
    'UMI',
    'PER',
    'URU',
    'BAR',
    'GUF',
    'GUY',
    'AIA',
    'GLP',
    'JAM',
    'GRN',
    'CHI',
    'TTO',
    'ARG',
    'LCA',
    'BES',
    'PAN',
    'GDL',
  ],
  Oceania: [
    'MNP',
    'ASA',
    'TUV',
    'SAM',
    'SOL',
    'PCN',
    'NZL',
    'NIU',
    'WLF',
    'PYF',
    'MHL',
    'CXR',
    'FSM',
    'KIR',
    'PNG',
    'VAN',
    'PLW',
    'NCL',
    'CCK',
    'NRU',
    'TKL',
    'TGA',
    'COK',
    'GUM',
    'NFK',
    'AUS',
    'FIJ',
  ],
  Antarctic: ['BVT', 'ATF', 'ATA', 'HMD', 'SGS'],
};
